import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Modal } from "antd";

import Icons from "components/icons";
import { Localize } from "components/service";


const AdditionalMenuModal = (props) => {

    const location = useLocation();
    const [ showModal, setShowModal ] = useState(false);

    useEffect(() => {
        setShowModal(false);
    }, [location]);

    return (
        <>
            <button
                className="additional-menu-button"
                type="button"
                aria-expanded={showModal}
                onClick={() => setShowModal(true)}
            >
                <span>
                    <span />
                    <span />
                    <span />
                </span>
            </button>
            <Modal
                title={
                    <Localize wrap="h3">GLOBAL.Modal_Title_Menu</Localize>
                }
                closeIcon={
                    <Icons.Close />
                }
                footer={ null }
                visible={ showModal }
                closable={true}
                onCancel={() => setShowModal(false)}
                wrapClassName="modal-actions additional-menu-modal"
                centered
            >
                { props.children }
            </Modal>
        </>
    );
};

export default AdditionalMenuModal;
